var React = require('react');

function IcAwsCloudfrontEdgeLocation (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M0,0v40h40V0H0z M38.298,1.702v20.996c-3.495-1.766-7.208-3.004-11.064-3.697v-6.236H12.766v6.236\n\tc-3.857,0.693-7.569,1.931-11.064,3.696V1.702H38.298z M25.532,14.468v11.064H14.468V14.468H25.532z M1.702,38.298v-13.68\n\tc3.48-1.856,7.194-3.16,11.064-3.886v6.502h14.468v-6.502c3.869,0.726,7.584,2.03,11.064,3.886v13.68\n\tC38.298,38.298,1.702,38.298,1.702,38.298z"}));
}

IcAwsCloudfrontEdgeLocation.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsCloudfrontEdgeLocation;

IcAwsCloudfrontEdgeLocation.default = IcAwsCloudfrontEdgeLocation;
